import { Typography, useTheme } from "@mui/material";
import { Button, CircleQuestionMarkIcon } from "components";

export const HowToConfigureBtn = () => {
  const theme = useTheme();
  return (
    <Button
      startIcon={
        <CircleQuestionMarkIcon
          color="primary"
          sx={{ width: "24px", height: "24px" }}
        />
      }
      onClick={() => {
        window.open(
          "https://support.deskday.com/en/articles/12853736-integrate-sso-and-sync-users-to-deskday",
          "_blank",
        );
      }}
      variant="ghost"
      sx={{ color: theme.palette.lightBg.high }}
    >
      <Typography sx={{ cursor: "pointer" }} variant="link-small">
        How to configure
      </Typography>
    </Button>
  );
};
